import React from "react";

import { FormattedMessage } from "react-intl";

import NavBar from "../../components/NavBar";
import NavBarItem from "../../components/NavBarItem";

import {
    restaurantRouteBuilder,
    restaurantP24TransactionRouteBuilder,
    restaurantP24MerchantRouteBuilder,
    restaurantP24LogRouteBuilder
} from "../../constants/routes";

/**
 * Górna nawigacja na komponencie restauracji
 */
const RestaurantNavBar = ({ match }) => {
  
    const restaurantId = match.params.id;

    return (

        <div className="p24NavBar">
            <NavBar className="w3-bar w3-black w3-small">
                <NavBarItem isVisible={true} url={restaurantRouteBuilder(restaurantId)}>
                    <i className="fas fa-dollar-sign w3-xxlarge" />
                    <p><FormattedMessage
                        id="app.restaurantPage.title"
                        defaultMessage="Restaurant"
                    /></p>
                </NavBarItem>
                <NavBarItem isVisible={true} url={restaurantP24TransactionRouteBuilder(restaurantId)}>
                    <i className="fas fa-user-tie w3-xxlarge" />
                    <p><FormattedMessage
                        id="app.restaurantPage.p24TransactionPage.title"
                        defaultMessage="P24 Transactions"
                    /></p>
                </NavBarItem>
                <NavBarItem isVisible={true} url={restaurantP24MerchantRouteBuilder(restaurantId)}>
                    <i className="fas fa-user-tie w3-xxlarge" />
                    <p><FormattedMessage
                        id="app.restaurantPage.p24MerchantPage.title"
                        defaultMessage="P24 Merchants"
                    /></p>
                </NavBarItem>
                <NavBarItem isVisible={true} url={restaurantP24LogRouteBuilder(restaurantId)}>
                    <i className="fas fa-compact-disc w3-xxlarge" />
                    <p><FormattedMessage
                        id="app.restaurantPage.p24LogPage.title"
                        defaultMessage="P24 Logs"
                    /></p>
                </NavBarItem>
                <span
                    className={'w3-bar-item w3-button w3-padding-large w3-black w3-hover-none w3-hover-text-theme w3-xlarge w3-right'}
                    url={restaurantRouteBuilder(restaurantId)}
                >
                    <p>{restaurantId}</p>
                </span>
            </NavBar>
        </div>

    )

}

export default RestaurantNavBar;